module.exports = __webpack_public_path__ + "fonts/Open_Sans-300-latin11.b871ad6.woff2";